import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ZoomIn, X } from 'lucide-react';
interface ImageZoomProps {
  src: string;
  alt: string;
  className?: string;
  aspectRatio?: string;
}
export function ImageZoom({
  src,
  alt,
  className = '',
  aspectRatio = 'aspect-[4/5]'
}: ImageZoomProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({
    x: 0,
    y: 0
  });
  const [showMagnifier, setShowMagnifier] = useState(false);
  const [cursorPosition, setCursorPosition] = useState({
    x: 0,
    y: 0
  });
  const imgRef = useRef<HTMLImageElement>(null);
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!imgRef.current) return;
    const {
      left,
      top,
      width,
      height
    } = imgRef.current.getBoundingClientRect();
    const x = (e.clientX - left) / width * 100;
    const y = (e.clientY - top) / height * 100;
    setPosition({
      x,
      y
    });
    setCursorPosition({
      x: e.clientX - left,
      y: e.clientY - top
    });
    setShowMagnifier(true);
  };
  const handleMouseLeave = () => {
    setShowMagnifier(false);
  };
  return <>
      <div className={`relative overflow-hidden cursor-zoom-in group ${className} ${aspectRatio}`} onClick={() => setIsOpen(true)} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} data-id="element-5322">
        <img ref={imgRef} src={src} alt={alt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-5323" />

        {/* Magnifier Lens Effect */}
        {showMagnifier && <div className="absolute pointer-events-none w-32 h-32 rounded-full border-2 border-white/50 shadow-xl bg-no-repeat hidden lg:block z-10" style={{
        backgroundImage: `url(${src})`,
        backgroundPosition: `${position.x}% ${position.y}%`,
        backgroundSize: '250%',
        left: `${cursorPosition.x - 64}px`,
        top: `${cursorPosition.y - 64}px`
      }} data-id="element-5324" />}

        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-300" data-id="element-5325" />

        <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm p-2 rounded-full shadow-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-5326">
          <ZoomIn className="w-5 h-5 text-charcoal-600" data-id="element-5327" />
        </div>
      </div>

      {/* Full Screen Modal */}
      <AnimatePresence data-id="element-5328">
        {isOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 md:p-8" onClick={() => setIsOpen(false)} data-id="element-5329">
            <button className="absolute top-4 right-4 md:top-8 md:right-8 text-white/70 hover:text-white p-2 bg-white/10 rounded-full hover:bg-white/20 transition-all z-50" onClick={e => {
          e.stopPropagation();
          setIsOpen(false);
        }} data-id="element-5330">
              <X className="w-8 h-8" data-id="element-5331" />
            </button>

            <motion.img initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} src={src} alt={alt} className="max-w-full max-h-full object-contain rounded-lg shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-5332" />
          </motion.div>}
      </AnimatePresence>
    </>;
}